import styled from 'styled-components';
import { TextInput } from '@ardoq/forms';
import { s16 } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import { TablesSelectionBaseTable } from './types';

const SearchContainer = styled.div`
  width: 100%;
  margin-bottom: ${s16};
`;

export const filterTables = <T extends TablesSelectionBaseTable>(
  search: string,
  tables: T[]
): T[] => {
  const sanitizedSearch = search.toLowerCase().trim();
  const searchTerms = sanitizedSearch.split(/[\s_]+/);

  return tables.filter(t => {
    const label = t.label.toLowerCase();
    const name = t.name.toLowerCase();
    return searchTerms.every(term => {
      return label.includes(term) || name.includes(term);
    });
  });
};

type TableSearchType = {
  search: string;
  placeholder: string;
  onSearch: (value: string) => void;
};

export const TableSearch = ({
  search,
  placeholder,
  onSearch,
}: TableSearchType) => {
  return (
    <SearchContainer>
      <TextInput
        leftIconName={IconName.SEARCH}
        value={search}
        onValueChange={onSearch}
        onClear={() => onSearch('')}
        placeholder={placeholder}
      />
    </SearchContainer>
  );
};
